import React from "react";
import { Button } from "@mui/material";

const containedButtonStyle = {
  color: "#FFFFFF",
  backgroundColor: "#BD4257",
  fontSize: "14px",
  fontWight: "500",
  fontFamily: "Inter",
  padding: "6px 16px",
  "&:hover": {
    backgroundColor: "#BD4257",
  },
};

type Props = {
  text: string;
  disabled: boolean;
  handleClick: () => void;
};

//1. isBuyBackEnable: false, currentForm: delivery form => Text: "Confirm preferences" => send request
//2. isBuyBackEnable: true, currentForm: delivery form => Text: "Next" => changeModalPage method
//3. isBuyBackEnable: true, currentForm: buyback form => "Confirm preferences" => send request

const ConformButton = ({ text, disabled, handleClick }: Props) => {
  return (
    <Button
      variant={"contained"}
      sx={containedButtonStyle}
      type={text.includes("Confirm") ? "submit" : "button"}
      disabled={disabled}
      onClick={handleClick}
    >
      {text}
    </Button>
  );
};

export default ConformButton;
